<template>
    <div>

        <div style="margin-left: 5px; margin-right: 5px; margin-top: 15px">
            <!--        <div style="margin-left: 10px; margin-bottom: 15px; font-size: large"><h3>提款明细</h3></div>-->
            <!--        <div style="padding-top: 10px; padding-left: 10px"><h2>提款明细</h2></div>-->

<!--            <Alert style="margin-left: 5px; margin-right: 5px; padding: 10px;">-->
<!--                <div style="color: red; font-size: 11px">-->
<!--                    <div><span>注：</span>①可提款金额不低于"{{limit_money}}元"，才可提款</div>-->
<!--                    <div><span style="color: #00000000">注：</span>②每月限提款一次，之前未提款的金额全部提出</div>-->
<!--                    <div v-if="pay_rule === '2'">-->
<!--                        <span style="color: #00000000">注：</span>③提款时间为：本月{{$common.getLimitPayTime().startDay}}日至{{$common.getLimitPayTime().endDay}}日-->
<!--                    </div>-->
<!--                </div>-->
<!--            </Alert>-->
            <wp_card v-if="user_pay_data && user_pay_data.length > 0"
                     style="box-shadow: 1px 2px 5px #909090"
            >
                <div slot="head"></div>
                <div>
                    <span><h3 style="margin-top: -5px; margin-bottom: 5px">可提款明细</h3></span>

                </div>
                <van-divider
                        :style="{borderColor: '#cccccc', 'margin-top': '6px', 'margin-bottom': '6px', 'margin-left': '-10px', 'margin-right': '-10px'}"/>
                <div style="margin-left: 2px">
                    <van-row style="font-size: 15px">
                        <van-col span="10">推广收入：</van-col>
                        <van-col span="8"><span style="color: red; font-size: 17px">￥{{user_pay_data[0].p_money.toFixed(2)}}</span>
                        </van-col>
                    </van-row>
                    <van-row style="font-size: 15px">
                        <van-col span="10">推荐收入：</van-col>
                        <van-col span="8"><span style="color: red; font-size: 17px">￥{{(user_pay_data[0].p_twomoney + user_pay_data[0].p_threemoney + user_pay_data[0].p_othermoney).toFixed(2)}}</span>
                        </van-col>
                    </van-row>
<!--                    <van-row style="font-size: 15px">-->
<!--                        <van-col span="10">下下级分成收入：</van-col>-->
<!--                        <van-col span="8"><span style="color: red; font-size: 17px">￥{{user_pay_data[0].p_threemoney.toFixed(2)}}</span>-->
<!--                        </van-col>-->
<!--                    </van-row>-->
                    <van-row v-if="user_type_can_pay > 0" style="font-size: 15px">
                        <van-col span="10">专属收入：</van-col>
                        <van-col span="8"><span style="color: red; font-size: 17px">￥{{user_pay_data[0].p_parentmoney.toFixed(2)}}</span>
                        </van-col>
                    </van-row>
                    <van-divider :style="{borderColor: '#cccccc', 'margin-top': '6px', 'margin-bottom': '6px'}"/>
                    <van-row style="height:40px;font-size: 16px; font-weight: bold">
                        <van-col span="10" style="line-height: 40px">合计收入：</van-col>
                        <van-col span="8" style="line-height: 40px">
                            <span style="color: red; font-size: 20px">￥{{user_pay_data[0].payallmoney.toFixed(2)}}</span>
                        </van-col>
<!--                        <van-col span="6" style="text-align: right; line-height: 40px">-->
<!--                            <van-button type="danger" round plain-->
<!--                                        size="small"-->
<!--                                        style="margin-right: 10px"-->
<!--                                        :disabled="click_pay_disable"-->
<!--                                        @click="clickPay"-->
<!--                            >提款-->
<!--                            </van-button>-->
<!--                        </van-col>-->
                    </van-row>

                </div>

                <van-action-sheet
                        v-model="pay_model"
                        title="提款"
                        style="height: 70%"
                >
                    <div style="padding: 10px">
                        <div style="margin-left: 5px; font-size: 17px">提款方式：{{pay_type_tag}}</div>

                        <div style="margin-top: 10px; margin-left: 5px; margin-right: 5px; background-color: #aaaaaa; padding: 1px; border-radius:4px">
                            <van-field
                                    style="border-radius:3px; font-size: 15px; background-color: #f0f0f0"
                                    v-model="pay_money_model"
                                    label="提款金额"
                                    readonly
                            />
                        </div>

                        <div v-if="!isWeChat"
                             style="margin-top: 10px; margin-left: 5px; margin-right: 5px; background-color: #aaaaaa; padding: 1px; border-radius:4px">
                            <van-field
                                    style="border-radius:3px; font-size: 15px"
                                    v-model="account_model"
                                    label="提款账号"
                                    :placeholder="account_placeholder"
                                    clearable
                                    required
                            />
                        </div>

                        <div style="margin-top: 10px; margin-left: 5px; margin-right: 5px; background-color: #aaaaaa; padding: 1px; border-radius:4px">
                            <van-field
                                    style="border-radius:3px; font-size: 15px;"
                                    v-model="truename_model"
                                    label="真实姓名"
                                    :placeholder="truename_placeholder"
                                    clearable
                                    required
                            />
                        </div>
                        <div v-if="isWeChat" style="margin-top: 10px; padding-left: 5px; padding-right: 5px; font-size: 15px; color: #FF0000">
                            *真实姓名必须是当前微信账号实名认证的姓名，否则会导致微信支付付款失败
                        </div>

                        <div v-if="isWeChat" style="margin-top: 10px; padding-left: 5px; padding-right: 5px">
                            <div v-if="wx_openid">
                                <van-cell style="border: 1px solid #aaaaaa; border-radius: 4px; padding-top: 5px; padding-bottom: 5px">
                                    <van-image slot="icon" v-if="wx_user_icon" style="width: 40px" :src="wx_user_icon" round />
                                    <div slot="title" v-if="wx_user_name" style="margin-left: 15px; font-size: 15px; font-weight: bold;margin-top: 10px">
                                        <div>
                                            <span style="font-size: 18px">{{wx_user_name}}</span>
                                        </div>
                                    </div>
                                </van-cell>
                                <div style="margin-top: 5px; margin-left: 5px; font-size: 15px; color: #FF0000">
                                    *请核对以上微信'头像'和'昵称'，若数据不符，请勿提款！关注[万品京选]公众号，重新登录后，再进行提款

                                </div>
                            </div>
                        </div>

                        <div style="margin-top: 20px; text-align: center">
                            <van-button plain round type="danger" size="small"
                                        style="width: 110px"
                                        @click="commitToPay"
                            >确认提款
                            </van-button>
                        </div>

                    </div>

                </van-action-sheet>

            </wp_card>

        </div>
        <van-collapse v-model="activeNames" style="margin-top: 20px">
            <van-collapse-item name="1">
                <div slot="title" ><h3>月收入明细</h3></div>

                <van-button slot="right-icon" plain round type="danger" size="mini" >{{collapse_righe_icon_1}}
                </van-button>

                <div v-if="user_pay_list_data && user_pay_list_data.length > 0">
                    <div v-for="(item, index) in user_pay_list_data" :key="index">
                        <div v-if="item.p_status === 1">
                            <div v-if="index !== 0" style="margin-top: 20px"></div>
                            <wp_card style="box-shadow: 1px 2px 5px #909090">
                                <div slot="head"></div>


                                <van-row style="margin-top: -5px">
                                    <van-col span="12">
                                        <h3 style="">{{item.p_month}}收入明细</h3>
                                    </van-col>
                                    <van-col span="12">
                                        <h3 style="text-align: right; font-size: 15px; color: #1289ff; text-decoration:underline"
                                            @click="getOrderByFinishXls(item.p_month)">当月订单明细</h3>
                                    </van-col>
                                </van-row>

                                <van-action-sheet
                                        :title="item.p_month + '订单明细'"
                                        v-model="showLink"

                                        style="padding-bottom: 20px; height: 50%"
                                >
                                    <div style="padding: 20px">
                                        <div style="font-size: 15px; border: 1px solid #77FFCC55; border-radius: 4px; padding: 10px; background-color: #77FFCC22">
                                            复制以下链接在手机浏览器中打开或下载<br>
                                            <span style="color: orange; font-size: 14px">*注：苹果手机无法下载</span>
                                        </div>
                                        <div style="text-align: center; font-size: 16px; margin-top: 20px">{{xls_file_path}}</div>

                                        <div style="text-align: center; width: 100%; padding-top: 30px">
                                            <van-sticky style="text-align: center;width: 100%">

                                                <van-button v-if="xls_file_path"
                                                            type="info"

                                                            style="width: 90%"
                                                            v-clipboard:copy="xls_file_path"
                                                            v-clipboard:success="onCopySuccess"
                                                            v-clipboard:error="onCoypError"
                                                >复制链接
                                                </van-button>

                                                <div v-if="copy_finish_text" style="margin-top: 10px">
                                                    <span :style="{color: copy_tip_color}">{{copy_finish_text}}</span>
                                                </div>

                                            </van-sticky>

                                        </div>
                                    </div>

                                </van-action-sheet>

                                <van-divider
                                        :style="{borderColor: '#cccccc', 'margin-top': '6px', 'margin-bottom': '6px', 'margin-left': '-10px', 'margin-right': '-10px'}"/>
                                <div style="margin-left: 2px">

                                    <van-row style="font-size: 15px">
                                        <van-col span="10">推广收入：</van-col>
                                        <van-col span="8"><span style="color: red; font-size: 17px">￥{{item.p_money.toFixed(2)}}</span>
                                        </van-col>
                                    </van-row>
                                    <van-row style="font-size: 15px">
                                        <van-col span="10">推荐收入：</van-col>
<!--                                        下级，下下级，非直属-->
                                        <van-col span="8"><span style="color: red; font-size: 17px">￥{{(item.p_twomoney + item.p_threemoney + item.p_othermoney).toFixed(2)}}</span>
                                        </van-col>
                                    </van-row>

                                    <van-row v-if="user_type_month_income > 0" style="font-size: 15px">
                                        <van-col span="10">专属收入：</van-col>
                                        <van-col span="8"><span style="color: red; font-size: 17px">￥{{item.p_parentmoney.toFixed(2)}}</span>
                                        </van-col>
                                    </van-row>
                                    <div v-if="user_type_month_income > 0">

                                    </div>

                                    <van-divider
                                            :style="{borderColor: '#cccccc', 'margin-top': '6px', 'margin-bottom': '6px'}"/>
                                    <van-row style="font-size: 18px; font-weight: bold">
                                        <van-col span="10">总收入：</van-col>
                                        <van-col span="8"><span style="color: red; font-size: 20px">￥{{item.payallmoney.toFixed(2)}}</span>
                                        </van-col>
                                    </van-row>

                                    <van-button id="stamp_button" ref="stamp_button" type="danger" plain size="small"
                                                style="width: auto; height: auto;border-radius: 3px;
                        padding: 3px;
                        position: absolute;right:10%;bottom:20%; background-color: #ffffff77;
                        transform: rotate(25deg)"
                                    >
                                        <van-button type="danger" plain hairline size="small"
                                                    style="border-radius: 3px;background-color: #ffffff77; "
                                        >已结算
                                        </van-button>
                                    </van-button>
                                </div>
                            </wp_card>
                        </div>
                    </div>
                </div>

            </van-collapse-item>
<!--            <van-collapse-item name="2">-->
<!--                <div slot="title" ><h3>提款明细</h3></div>-->

<!--                <van-button slot="right-icon" plain round type="danger" size="mini" >{{collapse_righe_icon_2}}-->
<!--                </van-button>-->

<!--                <div v-if="order_by_sumbit_list && order_by_sumbit_list.length > 0">-->

<!--                    <div v-for="(item, index) in order_by_sumbit_list" :key="index">-->
<!--                        <div v-if="index !== 0" style="margin-top: 20px"></div>-->
<!--                        <wp_card style="box-shadow: 1px 2px 5px #909090; color: #000000">-->
<!--                            <div slot="head"></div>-->
<!--                            <h3>-->
<!--                                <van-row style="font-size: 15px; margin-top: -5px;">-->
<!--                                    <van-col span="8">提款时间：</van-col>-->
<!--                                    <van-col span="16"><span style="color: red; font-size: 17px; ">{{formatSubTime(item.u_subtime)}}</span>-->
<!--                                    </van-col>-->
<!--                                </van-row>-->
<!--                            </h3>-->

<!--                            <van-divider-->
<!--                                    :style="{borderColor: '#cccccc', 'margin-top': '6px', 'margin-bottom': '6px', 'margin-left': '-10px', 'margin-right': '-10px'}"/>-->
<!--                            <div style="margin-left: 2px">-->

<!--                                <van-row style="font-size: 15px">-->
<!--                                    <van-col span="8">提款金额：</van-col>-->
<!--                                    <van-col span="16"><span style="color: red; font-size: 17px">￥{{item.u_submoney.toFixed(2)}}</span>-->
<!--                                    </van-col>-->
<!--                                </van-row>-->
<!--                                <van-row style="font-size: 15px">-->
<!--                                    <van-col span="8">提款状态：</van-col>-->
<!--                                    <van-col span="16">-->
<!--                                            <span style="color: red; font-size: 17px">-->
<!--                                                {{item.u_status_msg}}-->
<!--                                            </span>-->
<!--                                    </van-col>-->
<!--                                </van-row>-->
<!--                                <div v-if="item.u_finishtime">-->
<!--                                    <van-row style="font-size: 15px">-->
<!--                                        <van-col span="8">完成时间：</van-col>-->
<!--                                        <van-col span="16"><span style="color: red; font-size: 17px">{{item.u_finishtime}}</span></van-col>-->
<!--                                    </van-row>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </wp_card>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </van-collapse-item>-->
        </van-collapse>

    </div>
</template>

<script>
    import Vue from 'vue';
    import {Alert} from 'iview';
    import {Dialog} from 'vant';
    import wp_card from "../../waps_ui/wp_card";

    Vue.component('Alert', Alert);

    export default {
        name: "Wp_mt_pay_data",
        components: {wp_card},
        data() {
            return {
                //用户可提款金额数据
                user_pay_data: [],
                //用户提款明细数据
                user_pay_list_data: [],
                //提款按钮是否禁用
                click_pay_disable: false,

                pay_model: false,
                //提款账号
                account_model: "",
                //提款账号实名认证过的真实姓名
                truename_model: "",

                pay_money_model: '',
                //系统配置数据
                sub_config_data: [],
                //提现方式名称
                pay_type_tag: "",

                account_placeholder: "请输入账号",
                truename_placeholder: "请输入账号实名认证过的姓名",

                isWeChat: false,

                limit_money: "10",

                pay_rule: "2",

                activeNames: [],
                collapse_righe_icon_1: "展开",
                collapse_righe_icon_2: "展开",
                //提款明细记录
                order_by_sumbit_list:[],
                //提款时间
                u_subtime: "",

                xls_file_path: "",

                showLink: false,

                xls_data_href: null,

                copy_finish_text: "",
                copy_tip_color: "",

                wx_user_icon: "",
                wx_user_name: "",
                wx_openid: "",
                u_wx: 1,

                user_type_month_income: 0,
                // //月收入明细，推广收入
                // tuiguang_month_income: 0,
                // //月收入明细，推荐收入
                // tuijian_month_income: 0,
                // //月收入明细，专属收入
                // zhuanshu_month_income: 0,

                user_type_can_pay: 0,


            }
        },

        mounted() {
            this.getUserPayTo();
            this.getUserPayList();
            this.getOrderBySumbit();

            // this.getLimitPayTime();

            // this.$wx.miniProgram.getEnv(res => {
            //
            //     if (res.miniprogram) {
            //         alert("111")
            //     }else{
            //         alert("222")
            //     }
            // });

            //公众号
            if(this.$common.wx_user_info && this.$common.wx_user_info.openid){
                this.wx_openid = this.$common.wx_user_info.openid;
                this.wx_user_name = this.$common.wx_user_info.nickname;
                this.wx_user_icon = this.$common.wx_user_info.headimgurl;
                this.u_wx = 1;
            }

            //测试
            // this.$common.wx_user_info = {a:1};
            // this.wx_openid = "123";
            // this.wx_user_name = "凤梨罐头";
            // this.wx_user_icon = "https://wx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTKVztic66aV5IQAG7lQ2UO1JKSgINqfIyu1iaBJ1cickicxK1bSyFlLLaFxhYX2vgNmtg4DTibSCXKAAiaQ/132";

            //小程序
            if(this.$common.gloabl_wx_mini_user_info && this.$common.gloabl_wx_mini_user_info.open_id){
                this.wx_openid = this.$common.gloabl_wx_mini_user_info.open_id;
                this.wx_user_name = this.$common.gloabl_wx_mini_user_info.user_name;
                this.wx_user_icon = this.$common.gloabl_wx_mini_user_info.user_icon;
                this.u_wx = 2;

            }




        },

        methods: {

            onCopySuccess() {

                this.copy_finish_text = "复制成功";
                this.copy_tip_color = "limegreen";

                setTimeout(() => {

                    this.copy_finish_text = ""
                }, 5000);

                // window.navigator.clipboard.readText().then(clipText=>{
                //     this.$log(clipText)
                // })
            },

            onCoypError(){
                this.copy_finish_text = "复制失败";
                this.copy_tip_color = "red";

                setTimeout(() => {

                    this.copy_finish_text = ""
                }, 5000);
            },

            /**
             * 订单详情下载xls
             */
            getOrderByFinishXls(start_time){

                let params = {
                    pid: this.$common_mt.getPddPid(),
                    stime: start_time
                };
                // this.showLink = true;

                this.$getOrderByFinishXls_mt(params, response=>{
                    this.$log(response)
                    // window.location.href = response.download

                    if(response.download && typeof (response.download) !== "undefined"){
                        this.xls_file_path = response.download;

                        this.$log(this.xls_file_path)
                        this.showLink = true;
                    }else{
                        this.$dialog.alert({
                            message: "没有查到相关订单数据\n如有问题，请联系客服"
                        })
                    }

                    // window.open(this.xls_file_path)


                    // this.$getXls(this.xls_file_path, blob=>{
                    //     this.xls_data_href = window.URL.createObjectURL(blob);
                    //
                    //
                    //     let read=new FileReader();//创建读取器对象FileReader
                    //
                    //     read.readAsText(blob);//开始读取文件
                    //
                    //     read.οnlοad=function () {//数据读完会触发onload事件
                    //
                    //         this.$log(read.result);//read有个result属性存放这结果，从result获取到数据
                    //
                    //     }
                    //
                    //
                    //     // const a = document.createElement('a');
                    //     // a.href = this.xls_data_href;
                    //     // a.download = 'test.xls';
                    //     // document.body.appendChild(a);
                    //     // a.click();
                    //     // window.URL.revokeObjectURL(this.xls_data_href);
                    //     // document.body.removeChild(a);
                    //
                    //
                    //     this.showLink = true;
                    // })
                })
            },

            /**
             * 格式化提供时间
             */
            formatSubTime(u_subtime){
                return u_subtime.substring(0, u_subtime.indexOf(" "));
            },

            /**
             * 获取提款记录
             */
            getOrderBySumbit(){
                let params = {
                    uid: this.$store.state.username
                };

                this.$getOrderBySumbit_mt(params, response=>{

                    if(response && response.code === 200){
                        this.order_by_sumbit_list = response.data;
                    }
                })
            },



            /**
             * 确认提款
             */
            commitToPay() {

                if (this.truename_model && this.account_model) {
                    let params = {
                        uid: this.$store.state.username,
                        u_account: this.account_model,
                        u_truename: this.truename_model,
                        wx_user_name: this.wx_user_name,
                        wx_user_icon: encodeURIComponent(this.wx_user_icon),
                        u_wx: this.u_wx
                    };
                    this.$getUserSubmit_mt(params, response => {

                        this.$log(response);
                        if (response.code === 200) {
                            Dialog({message: "提款申请成功"});
                            this.pay_model = false;
                        } else if (response.code === 3001) {
                            Dialog({message: "提款申请纪录已存在，请不要重复提交"});
                            this.pay_model = false;
                        }
                    })
                } else {
                    //如果是微信，单独判断openid
                    if (this.sub_config_data[0].s_u_paytype === "2") {
                        if (!this.account_model || typeof (this.account_model) === "undefined") {
                            Dialog({message: "微信相关信息为空，请关注[万品京选]公众号，并重新登录"});
                            return;
                        }
                        if (!this.truename_model || typeof (this.truename_model) === "undefined") {
                            Dialog({message: "真实姓名为空，请按要求填写"});
                            return;
                        }
                    } else {
                        Dialog({message: "提款账号或真实姓名为空，请按要求填写"});
                    }

                }


            },

            /**
             * 全部金额
             */
            getAllAmount() {
                this.pay_money_model = this.user_pay_data[0].payallmoney.toFixed(2);
            },

            /**
             * 提款
             */
            clickPay() {

                let paytype = this.sub_config_data[0].s_u_paytype;

                this.$log("paytype = " + paytype)

                // paytype = "0";
                if (paytype === "0") {
                    //支付宝
                    this.pay_type_tag = "支付宝";
                    if (this.$store.state.alipay && typeof (this.$store.state.alipay) !== "undefined") {
                        this.account_model = this.$store.state.alipay;
                    }
                } else if (paytype === "1") {
                    //银行卡
                    this.pay_type_tag = "银行卡";
                    if (this.$store.state.cardNomber && typeof (this.$store.state.cardNomber) !== "undefined") {
                        this.account_model = this.$store.state.cardNomber;
                    }
                } else if (paytype === "2") {
                    //微信
                    this.pay_type_tag = "微信";
                    // if (this.$store.state.openid && typeof (this.$store.state.openid) !== "undefined") {
                    //     this.account_model = this.$store.state.openid;
                    // }
                    if(!this.account_model || typeof (this.account_model) === "undefined"){

                        //从临时缓存中获取openid
                        if(this.wx_openid){
                            this.account_model = this.wx_openid;
                        }else{
                            this.pay_model = false;
                            this.$dialog.alert({
                                message: "微信相关信息为空，请在[万品京选]公众号，重新登录并提款"
                            })
                            return;
                        }
                    }
                    this.isWeChat = true;
                } else if (paytype === "3") {

                    //关闭
                    this.click_pay_disable = true;
                }

                //真实姓名
                if (this.$store.state.truename && typeof(this.$store.state.truename) !== "undefined") {
                    this.truename_model = this.$store.state.truename;
                }


                this.account_placeholder = "请输入" + this.pay_type_tag + "账号";
                this.truename_placeholder = "请输入" + this.pay_type_tag + "账号实名认证过的姓名";

                //弹出sheet
                this.pay_model = true;
            },

            /**
             * 获取系统配置
             */
            getSubConfig() {
                this.$getSubConfig_mt(response => {
                    //测试
                    //陈总的账号 V016 V017 V039 A138   王海燕V011    张欢欢V019    单金杰V075
                    // let u_names = "s101,V016,V017,V039,A138,V011,V019,V075,S140";
                    // if(u_names.toLowerCase().indexOf(this.$store.state.username.toLowerCase()) !== -1){
                    //     // response = {"msg":"sucess","code":200,"data":[{"s_vcode":"C1SV024F","s_u_fee":"50","s_u_num":"1","s_three_fee":"5","s_u_rule":"1","s_u_minmoney":"10","s_two_fee":"10","s_u_paytype":"2"}]};
                    //     response = {
                    //         "msg": "sucess",
                    //         "code": 200,
                    //         "data": [{
                    //             "s_vcode": "C1SV024F",
                    //             "s_u_fee": "50",//分成比例
                    //             "s_u_num": "1",//用户可提现次数
                    //             "s_three_fee": "5",//下下级分成比例
                    //             "s_u_rule": "2",//1随时提现 2 固定每月提现（每月21号后可提现）
                    //             "s_u_minmoney": "0",//用户提现最小金额
                    //             "s_two_fee": "10",//下级分成比例
                    //             "s_u_paytype": "2"//提现方式 0支付宝1银行卡2微信3关闭
                    //         }]
                    //     };
                    // }

                    //
                    this.sub_config_data = response.data;

                    this.limit_money = this.sub_config_data[0].s_u_minmoney;
                    this.pay_rule = this.sub_config_data[0].s_u_rule;
                    // this.pay_rule = "1";
                    if (this.pay_rule === "2") {
                        //如果是固定每月提现（每月21号后可提现），则判断当前时间，21、22两天，提款按钮可用，否则提款按钮禁用
                        if (this.$common.getLimitPayTime().canPay) {
                            this.click_pay_disable = false;
                        } else {
                            this.click_pay_disable = true;
                        }
                    }

                    //提款金额小于最小可提款金额时，提款按钮禁用
                    if (this.user_pay_data[0].payallmoney < Number(this.limit_money)) {
                        this.click_pay_disable = true;
                    }

                    if(this.sub_config_data[0].s_u_paytype === "3"){
                        this.click_pay_disable = true;

                        this.$dialog.alert({
                            // message: "分成收入正在统计中，请稍微再试"
                            message: "当前时间不可提款，请在下一个提款时间进行提款"
                        })
                    }

                    // this.pay_rule = "1";
                    // //获取限制时间数据（this.pay_rule在其中使用）
                    // this.getLimitPayTime();

                    // this.click_pay_disable = false;

                })
            },

            /**
             * 获取用户可提款金额数据
             */
            getUserPayTo() {
                let params = {
                    uid: this.$store.state.username,
                    pid: this.$common_mt.getPddPid(),
                };

                this.$getUserPayTo_mt(params, response => {
                    // this.$log("response = " + response)
                    //测试
                    // response = {"msg":"success","code":200,"data":[{"p_status":0,"p_twomoney":325.42800000000005,"p_threemoney":18.4205,"u_mark":"v156","payallmoney":1950.3185,"id":0,"p_money":1606.47,"u_pid":"1825325610"}]};

                    if (response && response.code === 200) {
                        this.user_pay_data = response.data;
                        this.user_type_can_pay = response.u_type;

                        this.pay_money_model = "￥" + this.user_pay_data[0].payallmoney.toFixed(2);

                        //获取系统配置
                        // this.getSubConfig();
                    }
                });
            },

            /**
             * 获取用户月收入明细数据
             */
            getUserPayList() {
                let params = {
                    uid: this.$store.state.username,
                    pid: this.$common_mt.getPddPid(),
                };

                this.$getUserPayList_mt(params, response => {
                    this.$log("response = " + response)
                    if(response && response.code === 200){
                        this.user_pay_list_data = response.data;
                        this.user_type_month_income = response.u_type;
                    }
                });
            }

        },
        watch:{
            activeNames(value) {
                if (value && value.length > 0) {

                    if(value.includes("1")){
                        this.collapse_righe_icon_1 = '收起';
                    }else{
                        this.collapse_righe_icon_1 = '展开';
                    }

                    if(value.includes("2")){
                        this.collapse_righe_icon_2 = '收起';
                    }else{
                        this.collapse_righe_icon_2 = '展开';
                    }

                } else {
                    this.collapse_righe_icon_1 = '展开';
                    this.collapse_righe_icon_2 = '展开';
                }
            }
        }
    }
</script>

<style scoped>

</style>
